module.exports = __webpack_public_path__ + "img/黄芪.558015e5.jpg";